import { Handler } from '../types'

export const all = (...handlers: Handler<any>[]): Handler =>
  async (ctx) => { await Promise.all(handlers.map(handler => handler(ctx))) }
